import { render, staticRenderFns } from "./AssignmentCard.vue?vue&type=template&id=147e45a4&scoped=true&"
import script from "./AssignmentCard.vue?vue&type=script&lang=js&"
export * from "./AssignmentCard.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCard.vue?vue&type=style&index=0&id=147e45a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e45a4",
  null
  
)

export default component.exports